import {
  $applyNodeReplacement,
  DecoratorNode,
  type NodeKey,
  type SerializedLexicalNode,
  type Spread,
} from "lexical";
import type { ReactElement } from "react";
import { UserMention } from "./regulation/UserMention";
import { serializeUserMention } from "../composer-user-mentions";
type SerializedUserNode = Spread<
  { userId: string; label: string; type: "composer-user"; version: 1 },
  SerializedLexicalNode
>;
export class ComposerUserNode extends DecoratorNode<ReactElement> {
  __userId: string;
  __label: string;
  static override getType() {
    return "composer-user";
  }
  static override clone(node: ComposerUserNode) {
    return new ComposerUserNode(node.__userId, node.__label, node.__key);
  }
  static override importJSON(node: SerializedUserNode) {
    return $createComposerUserNode(node.userId, node.label).updateFromJSON(node);
  }
  constructor(userId: string, label: string, key?: NodeKey) {
    super(key);
    this.__userId = userId;
    this.__label = label;
  }
  override exportJSON(): SerializedUserNode {
    return {
      ...super.exportJSON(),
      userId: this.__userId,
      label: this.__label,
      type: "composer-user",
      version: 1,
    };
  }
  override createDOM() {
    const dom = document.createElement("span");
    dom.className = "composer-inline-chip relative inline-flex align-middle leading-none";
    return dom;
  }
  override updateDOM(): false {
    return false;
  }
  override getTextContent() {
    return serializeUserMention(this.__label, this.__userId);
  }
  override isInline(): true {
    return true;
  }
  override decorate() {
    return <UserMention userId={this.__userId} label={this.__label} />;
  }
}
export function $createComposerUserNode(userId: string, label: string) {
  return $applyNodeReplacement(new ComposerUserNode(userId, label));
}
